export type DomainKey = "ai" | "forex" | "crypto" | "usStock" | "tianji";

export interface DomainFlags {
  ai: boolean;
  forex: boolean;
  crypto: boolean;
  usStock: boolean;
  tianji: boolean;
}

export type DomainEnv = Partial<Record<"VITE_DOMAIN_AI" | "VITE_DOMAIN_FOREX" | "VITE_DOMAIN_CRYPTO" | "VITE_DOMAIN_US_STOCK" | "VITE_DOMAIN_TIANJI", string>>;

export const enabledDomains: DomainFlags = {
  ai: __DOMAIN_AI__,
  forex: __DOMAIN_FOREX__,
  crypto: __DOMAIN_CRYPTO__,
  usStock: __DOMAIN_US_STOCK__,
  tianji: __DOMAIN_TIANJI__,
};

export function resolveDomainFlags(env: DomainEnv): DomainFlags {
  const keys: Array<keyof DomainEnv> = [
    "VITE_DOMAIN_AI",
    "VITE_DOMAIN_FOREX",
    "VITE_DOMAIN_CRYPTO",
    "VITE_DOMAIN_US_STOCK",
    "VITE_DOMAIN_TIANJI",
  ];
  const hasExplicitDomainScope = keys.some((key) => env[key] !== undefined);
  const defaultEnabled = !hasExplicitDomainScope;
  const enabled = (key: keyof DomainEnv) => {
    const value = env[key];
    if (value === undefined) return defaultEnabled;
    return value === "true" || value === "1";
  };

  return {
    ai: enabled("VITE_DOMAIN_AI"),
    forex: enabled("VITE_DOMAIN_FOREX"),
    crypto: enabled("VITE_DOMAIN_CRYPTO"),
    usStock: enabled("VITE_DOMAIN_US_STOCK"),
    tianji: enabled("VITE_DOMAIN_TIANJI"),
  };
}

export function isDomainPathEnabled(path: string, flags: DomainFlags = enabledDomains) {
  if (path.startsWith("/ai")) return flags.ai;
  if (path.startsWith("/forex")) return flags.forex;
  if (path.startsWith("/us-stock")) return flags.usStock;
  if (path.startsWith("/tianji")) return flags.tianji;
  return flags.crypto;
}

export function firstEnabledDomain(flags: DomainFlags = enabledDomains): "crypto" | "us_stock" | "forex" | "ai_image" | "tianji" {
  if (flags.ai) return "ai_image";
  if (flags.forex) return "forex";
  if (flags.crypto) return "crypto";
  if (flags.tianji) return "tianji";
  if (flags.usStock) return "us_stock";
  return "crypto";
}

export function firstEnabledDomainPath(flags: DomainFlags = enabledDomains) {
  if (flags.ai) return "/ai/reports";
  if (flags.forex) return "/forex/overview";
  if (flags.crypto) return "/crypto/overview";
  if (flags.tianji) return "/tianji/overview";
  if (flags.usStock) return "/us-stock";
  return "/";
}
